// extracted by mini-css-extract-plugin
export default {"main":"Project_main__Q2EVP","text":"Project_text__zJU6y","projectImage":"Project_projectImage__4x74t","button":"Project_button__rzfto"};